module.exports = __webpack_public_path__ + "static/media/Hjerne.f949a946.mp3";